import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../utl/models/Error";
import { GroupsState } from "../models/GroupsState";

const setError = (state: GroupsState, action: PayloadAction<Error>) => {
    state.isError = action.payload.error;
}

export default setError;